var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed pull-right",attrs:{"id":"footer"}},[_c('strong',[_vm._v("\n    © 2019 电子商城后台管理系统\n    "),_c('span',{staticClass:"m-l-20"},[_vm._v(_vm._s(_vm.helloMessage))])])])}
var staticRenderFns = []

export { render, staticRenderFns }